const state = {
  currentTab: "mistakesCollection",
  activeSub: {
    mistakesCollection: 1,
    examCenter: 1,
    mistakesDownload:1
  }
};
const mutations = {
  SET_CURRENT_TAB: (state, tab) => {
    state.currentTab = tab;
  },
  SET_ACTIVE_SUB: (state, data) => {
    const { tab,sub} = data
    state.activeSub[tab] = sub;
  }
};

const actions = {
  setCurrentTab({ commit }, tab) {
    commit("SET_CURRENT_TAB", tab);
  },
  setActiveSub({ commit }, data) {
    commit("SET_ACTIVE_SUB", data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/mistakes.js